module.exports = __webpack_public_path__ + "img/how-to-1.ffd24b62.png";